import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Mail, ArrowUpRight } from "lucide-react";
import { CONTACT, logo } from "@/data/content";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[70] flex flex-col items-end gap-4">
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="chat-widget-panel"
            initial={{ opacity: 0, y: 18, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 18, scale: 0.95 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="w-[320px] glass rounded-3xl p-6 shadow-2xl shadow-black/15"
          >
            <div className="flex items-center justify-between">
              <img src={logo} alt="Pacific Investment Group" className="h-10 w-10 rounded-lg object-cover ring-1 ring-gold/40" />
              <button
                data-testid="chat-widget-close"
                onClick={() => setOpen(false)}
                className="text-slate-600 hover:text-gold-deep transition-colors duration-300"
                aria-label="Close chat"
              >
                <X size={18} />
              </button>
            </div>
            <p className="mt-4 font-display text-2xl text-navy-900">Have a project in mind?</p>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              Our team typically replies within minutes on WhatsApp.
            </p>
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="chat-whatsapp-button"
              className="btn-gold mt-5 flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold"
            >
              Chat on WhatsApp
              <ArrowUpRight size={15} strokeWidth={2.25} />
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="chat-email-button"
              className="btn-ghost-gold mt-3 flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-sm"
            >
              Email us
              <Mail size={15} strokeWidth={1.75} />
            </a>
            <p className="mt-4 text-center text-[11px] text-slate-500">Mon–Fri, 9:00–18:00 EST</p>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        data-testid="chat-widget-bubble"
        onClick={() => setOpen(!open)}
        aria-label={open ? "Close chat" : "Open chat"}
        className="btn-gold flex h-14 w-14 items-center justify-center rounded-full shadow-xl shadow-gold/25"
      >
        {open ? <X size={24} strokeWidth={2} /> : <MessageCircle size={24} strokeWidth={1.75} />}
      </button>
    </div>
  );
}
